"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCertificateLowFillRateAndShouldBeExcludedFromFilter = void 0;
const LOW_FILL_RATE_CERTIFICATES_TO_EXCLUDE_FROM_FILTER = new Set([
    'NO_DOCUMENT_REQUIRED',
    'CRIMINAL_RECORD',
    'PICTURE',
    'ACCOMMODATION_CERTIFICATE',
    'MEDICAL_CHECK_PRO',
    'SWORN_STATEMENT',
    'VACCINATION_PASSPORT',
    'FISCAL_DECLARATION',
    'STATE_CERTIFICATE_DISABILITY',
    'STATE_CERTIFICATE_FAMILY_DISABILITY',
]);
const isCertificateLowFillRateAndShouldBeExcludedFromFilter = (documentType) => LOW_FILL_RATE_CERTIFICATES_TO_EXCLUDE_FROM_FILTER.has(documentType);
exports.isCertificateLowFillRateAndShouldBeExcludedFromFilter = isCertificateLowFillRateAndShouldBeExcludedFromFilter;
